module.exports = __webpack_public_path__ + "DivyanshuSoni-a02909ff.webp";